/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Hint_Tools_Auto_Choice_DisabledInputs */



/**
* | output |
* | --- |
* | "Tool calling is switched off on this server. For vLLM, start it with --enable-auto-tool-choice and --tool-call-parser. The model works without tools." |
*
* @param {Private_Models_Hint_Tools_Auto_Choice_DisabledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_hint_tools_auto_choice_disabled = /** @type {((inputs?: Private_Models_Hint_Tools_Auto_Choice_DisabledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Hint_Tools_Auto_Choice_DisabledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tool-Aufrufe sind auf diesem Server abgeschaltet. vLLM muss dafür mit --enable-auto-tool-choice und --tool-call-parser starten. Ohne Tools funktioniert das Modell.")
	return /** @type {LocalizedString} */ ("Tool calling is switched off on this server. For vLLM, start it with --enable-auto-tool-choice and --tool-call-parser. The model works without tools.")
});